import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/lib/Image';
import classnames from 'classnames';
import Utils from '../Utils';
import Classes from '../Classes';

const ExhibitorImage = ({
  src, alt, imageSize, deviceType, tag, isRounded, exhibitorId, defaultLogoUrl
}) => {
  const imageUrl = src ? Utils.getResizedImage(src, deviceType, imageSize) : defaultLogoUrl;

  return (
    <div className={Classes.relative}>
      <Image
        responsive
        className={classnames(Classes.centerBlock, { [Classes.roundCorners]: isRounded })}
        src={imageUrl}
        data-dtm={tag}
        data-dtm-attributes={JSON.stringify({ exhibitorId })}
        alt={alt}
        onError={() => {}}
      />
    </div>
  );
};

ExhibitorImage.propTypes = {
  src: PropTypes.string,
  imageSize: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  alt: PropTypes.string,
  exhibitorId: PropTypes.string,
  tag: PropTypes.string,
  defaultLogoUrl: PropTypes.string.isRequired,
  isRounded: PropTypes.bool
};

export default ExhibitorImage;
